import ColorNameMapper from '../../lib/jin/jwchartlib-v0/includes/primitives/Color_Data'

export default ColorNameMapper